/**
 * 로컬 스토리지 및 세션 스토리지 키 상수 정의
 * 
 * - LAST_AUTH_EMAIL: 마지막으로 인증번호를 발송한 이메일 주소 (재인증 시 자동 채움용)
 * - HAS_SEEN_INTRO: 인트로(언어 선택)를 완료했거나 통과한 기기인지 여부
 */
export const LAST_AUTH_EMAIL = 'moowoo_last_auth_email';
export const HAS_SEEN_INTRO = 'moowoo_has_seen_intro';
export const INVITE_JOIN_IN_PROGRESS = 'inviteJoinInProgress';
export const INVITE_OAUTH_PENDING = 'moowoo_invite_oauth_pending';
export const INVITE_SAVED_SEARCH = 'moowoo_invite_saved_search';
export const INVITE_SAVED_AT = 'moowoo_invite_saved_at';
export const ACCOUNT_DELETED_FLAG = 'moowoo_account_deleted';

/**
 * 사용자별 푸시 알림 배너 '나중에' 숨김 로컬 스토리지 키 생성
 * @param {string} userId - 사용자 ID
 * @returns {string}
 */
export const getPushPromptDismissedKey = (userId) => `moowoo_push_prompt_dismissed_${userId || 'anon'}`;
